/**
 * TanStack Query hooks for `kochava-generic-postback-template`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	kochavaGenericPostbackTemplateQueryKeys,
	type CreateKochavaGenericPostbackTemplateBody,
	type ListKochavaGenericPostbackTemplateResponse,
	type KochavaGenericPostbackTemplateRow,
} from "./api";

export function useKochavaGenericPostbackTemplateList(): UseQueryResult<ListKochavaGenericPostbackTemplateResponse, Error> {
	return useQuery({
		queryKey: kochavaGenericPostbackTemplateQueryKeys.list(),
		queryFn: list,
	});
}

export function useKochavaGenericPostbackTemplateCreate(): UseMutationResult<KochavaGenericPostbackTemplateRow, Error, CreateKochavaGenericPostbackTemplateBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kochavaGenericPostbackTemplateQueryKeys.all });
		},
	});
}

export function useKochavaGenericPostbackTemplateDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kochavaGenericPostbackTemplateQueryKeys.all });
		},
	});
}
